import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/health')({
  component: HealthComponent,
});

function HealthComponent() {
  return (
    <div>
      <h1>OK</h1>
    </div>
  );
}